import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { triggerPublicEvent, PublicEvents } from '@project/shared/utils/events/js/events';
import { floatControlLabel } from '@project/shared/utils/form-control/js/form-control';

@createModule('InputTextarea')
/**
 * input-textarea module implementation.
 *
 * @author Nele Rabus <nele.rabus@namics.com>
 */
export class InputTextarea extends TerrificSpec {
	start(resolve: Function) {
		this._ctx.addEventListener('change', () => this._triggerChangeEvent());
		this._ctx.addEventListener('click', () => floatControlLabel(this._ctx, true));
		this._ctx.addEventListener('focus', () => floatControlLabel(this._ctx, true));

		floatControlLabel(this._ctx);
		resolve();
	}
	stop() {
		this._ctx.removeEventListener('change', () => {});
		this._ctx.removeEventListener('click', () => {});
	}

	_triggerChangeEvent() {
		triggerPublicEvent(PublicEvents.uxChange, this, this._ctx);
		floatControlLabel(this._ctx);
	}

	/**
	 * Set the value of the input field
	 */
	setValue(value: string) {
		(this._ctx as HTMLInputElement).value = value;
	}

	/**
	 * Get the value of the input field
	 */
	getValue() {
		return (this._ctx as HTMLInputElement).value;
	}
}
